import {createContext} from 'react';

import type {ImageStore} from '../services/Image.service';

export const ImageStoreContext = createContext<ImageStore | undefined>(
    undefined,
);
